import {environment} from '@/config/environment';
import {appConfig} from '@/config/appConfig';

/**
 * Gets the authentication redirect URL for the current platform.
 *
 * For hybrid apps:
 * - MSAL/Azure: {appId}://msauth
 * - OIDC: {appId}://login
 *
 * @param path - Path ('msauth' for Azure/Microsoft, 'login' for OIDC)
 * @returns The redirect URL
 */
export async function getAuthenticationRedirectUrl(path: 'msauth' | 'login'): Promise<string> {
    if (!__IS_HYBRID_APP__) {
        // Use dev url for local development (*.local domains)
        if (appConfig.isLocalDevelopment) {
            return environment.VITE_DEV_BASE_URL!;
        }

        return window.location.origin;
    }

    const {App} = await import('@capacitor/app');
    const {id} = await App.getInfo();
    return `${id}://${path}`;
}
